import {performHttpRequest} from "@/http/http";

export async function deleteFile(domainID, presentationID, formAttributeID, domainListKey, domainListItem) {

    return performHttpRequest(
        `${window.kaartViewerUrl}/admin/v2/kaartviewerapi/bookmark/${window.websiteName}/domain/${domainID}/presentation/${presentationID}/formattribute/${formAttributeID}/item/${domainListKey}/featureid/${domainListItem.Name}?_=${new Date().getTime()}`,
        'DELETE'
    )
}

